import React from 'react';
export type AutomationStatus = 'Active' | 'Paused' | 'Error' | 'Draft' | 'Success' | 'Failed' | 'Filtered' | 'Retrying';
interface StatusPillProps {
  status: AutomationStatus;
}
export function StatusPill({
  status
}: StatusPillProps) {
  let cls = 'bg-[var(--colors-neutral-100)] text-[var(--colors-neutral-600)]';
  switch (status) {
    case 'Active':
    case 'Success':
      cls = 'bg-[var(--colors-success-light)] text-[var(--colors-success-dark)]';
      break;
    case 'Paused':
    case 'Filtered':
      cls = 'bg-[var(--colors-neutral-100)] text-[var(--colors-neutral-600)]';
      break;
    case 'Error':
    case 'Failed':
      cls = 'bg-[var(--colors-error-light)] text-[var(--colors-error-dark)]';
      break;
    case 'Draft':
    case 'Retrying':
      cls = 'bg-[var(--colors-info-light)] text-[var(--colors-info-dark)]';
      break;
  }
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded text-xs font-medium ${cls}`} data-id="element-2851">
      {status}
    </span>;
}